export var LABELED_CONTROL_POSITIONS = Object.freeze({
  left: 'left',
  right: 'right'
});